export const RECEIVE_LAND_PACKAGES = 'RECEIVE_LAND_PACKAGES'

export const setLandPackages = landPackages => ({
  type: RECEIVE_LAND_PACKAGES,
  payload: landPackages
})
